(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4701],{

/***/ 87847:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/[...slug]",
      function () {
        return __webpack_require__(18098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 18131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ClassBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/domain/Classes/getTextBasedOnType.js
function getTextBasedOnType(t) {
    switch(t){
        case "in_person":
            return "Presencial";
        case "virtual":
            return "Virtual";
        default:
            return "Sin definir";
    }
};

;// CONCATENATED MODULE: ./src/domain/Classes/getIconBasedOnType.js

function getIconBasedOnType(t) {
    switch(t){
        case "in_person":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-4 h-4",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                })
            });
        case "virtual":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-4 h-4",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z",
                    clipRule: "evenodd"
                })
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/domain/Classes/ClassBadge.js





var defaultProps = {
    roundedFull: false
};
var propTypes = {
    type: prop_types_default().oneOf([
        "virtual",
        "in_person"
    ]).isRequired,
    roundedFull: (prop_types_default()).bool
};
function ClassBadge(param) {
    var type = param.type, roundedFull = param.roundedFull;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("rounded-full text-sm px-3 py-1 inline-flex items-center font-medium", {
            "lg:rounded-r-none": roundedFull === false,
            "bg-teal-100 text-teal-900": type === "virtual",
            "bg-indigo-100 text-indigo-900": type === "in_person"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "leading-5 py-1 px-2 inline-flex items-center space-x-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "opacity-75",
                    children: getIconBasedOnType(type)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " tracking-tight font-semibold text-xs",
                    children: getTextBasedOnType(type)
                })
            ]
        })
    });
};
ClassBadge.defaultProps = defaultProps;
ClassBadge.propTypes = propTypes;


/***/ }),

/***/ 7122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClassDatesBlocksList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95888);




function ClassDatesBlocksList(param) {
    var dates = param.dates;
    var today = moment__WEBPACK_IMPORTED_MODULE_1___default()();
    return dates.map(function(param) {
        var date = param.date, time = param.time, timeEnd = param.timeEnd;
        var d = moment__WEBPACK_IMPORTED_MODULE_1___default()(date, "MM-DD-YYYY");
        var isBeforeToday = d.isBefore(today);
        var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("text-gray-900 border relative border-transparent rounded lg:rounded-lg bg-white w-24 flex flex-col items-center text-center py-4 px-5 space-y-1 focus:outline-none select-none mr-4", isBeforeToday === true && "poiner-events-none opacity-60 ring-1 ring-black ring-opacity-10", isBeforeToday === false && "cursor-pointer transition ease-in-out duration-100 hover:shadow-lg focus:ring-2 focus:ring-green-500 ring-1 ring-black ring-opacity-10 shadow hover:ring-opacity-20 focus:bg-green-50"),
            tabIndex: "-1",
            children: [
                isBeforeToday && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    tooltip: "Clase no disponible",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "text-gray-300 hover:text-gray-500",
                        type: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 top-0 mr-2 mt-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "w-4 h-4",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                    clipRule: "evenodd"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-gray-500 uppercase font-bold leading-none tracking-wide text-sm -mr-1",
                    children: d.format("MMM")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "uppercase text-4xl font-bold tracking-tighter leading-none",
                    children: d.format("DD")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-gray-600 font-bold text-xs leading-none tracking-wider whitespace-nowrap",
                    children: d.format("YYYY")
                })
            ]
        }, date);
        if (isBeforeToday === true) {
            return content;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            tooltip: "".concat(time, " - ").concat(timeEnd),
            children: content
        });
    });
};


/***/ }),

/***/ 73893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buyTrainingLink; }
/* harmony export */ });
function buyTrainingLink(productId) {
    return "".concat("https://tienda.aibes.org/", "/entrenamiento/carrito?producto=").concat(productId);
};


/***/ }),

/***/ 18098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Class; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/domain/buyTrainingLink.js
var buyTrainingLink = __webpack_require__(73893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/domain/Classes/ClassDateItem.js


var defaultProps = {};
var propTypes = {
    date: (prop_types_default()).string.isRequired,
    time: (prop_types_default()).string.isRequired
};
function ClassDateItem(param) {
    var date = param.date, time = param.time;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex w-full space-x-2 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center w-full space-x-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-sm font-semibold text-gray-900 whitespace-nowrap",
                    children: date
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1 border-t border-gray-400 border-dashed"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-violet-500 text-xs text-right whitespace-nowrap lowercase",
                    children: time
                })
            ]
        })
    });
};
ClassDateItem.defaultProps = defaultProps;
ClassDateItem.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/domain/Classes/ClassDates.js



var ClassDates_defaultProps = {
    dates: []
};
var ClassDates_propTypes = {
    dates: prop_types_default().arrayOf(prop_types_default().shape({
        date: (prop_types_default()).string,
        time: (prop_types_default()).string
    }))
};
function ClassDates_ClassDates(param) {
    var dates = param.dates;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col p-4 rounded",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col space-y-1",
            children: dates.map(function(param) {
                var date = param.date, time = param.time;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassDateItem, {
                        date: date,
                        time: time
                    })
                }, date);
            })
        })
    });
};
ClassDates_ClassDates.defaultProps = ClassDates_defaultProps;
ClassDates_ClassDates.propTypes = ClassDates_propTypes;

// EXTERNAL MODULE: ./src/domain/Classes/ClassBadge.js + 2 modules
var ClassBadge = __webpack_require__(18131);
;// CONCATENATED MODULE: ./src/domain/Classes/ClassInfoPanel.js






function ClassInfoPanelSection(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col space-y-1 py-4 lg:py-6",
        children: [
            /*#__PURE__*/ _jsx("h5", {
                className: "font-semibold",
                children: title
            }),
            children
        ]
    });
}
function ClassInfoPanelDates(param) {
    var dates = param.dates;
    if (dates === undefined || dates === null || dates.length === 0) {
        return null;
    }
    var ref = useState(false), isOpen = ref[0], setOpen = ref[1];
    var toggleDates = useCallback(function() {
        setOpen(function(isOpen) {
            return !isOpen;
        });
    }, [
        isOpen
    ]);
    var moreThanThreeDates = dates.length > 3;
    return /*#__PURE__*/ _jsxs(ClassInfoPanelSection, {
        title: "Fechas",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("-mx-6 -my-4 px-2 relative border-t border-b", {
                    "h-28": moreThanThreeDates,
                    "overflow-hidden border-transparent": moreThanThreeDates && isOpen === false,
                    "overflow-auto border-gray-200 bg-gray-100 scrollbar-thin scrollbar-thumb-gray-300 hover:scrollbar-thumb-gray-300": moreThanThreeDates && isOpen === true
                }),
                children: [
                    /*#__PURE__*/ _jsx(ClassDates, {
                        dates: dates
                    }),
                    moreThanThreeDates && isOpen === false && /*#__PURE__*/ _jsx("div", {
                        className: "bg-gradient-to-t from-white to-transparent absolute w-full left-0 right-0 bottom-0 h-20"
                    })
                ]
            }),
            moreThanThreeDates && /*#__PURE__*/ _jsx("div", {
                className: "flex justify-start pt-4",
                children: /*#__PURE__*/ _jsx("button", {
                    onClick: toggleDates,
                    className: "font-medium focus:outline-none hover:text-green-500 focus:ring-2 focus:ring-gray-900 px-3 py-1 inline-flex leading-5 rounded-full focus:bg-gray-900 focus:text-white",
                    type: "button",
                    children: isOpen ? "Ocultar fechas" : "Mostrar fechas"
                })
            })
        ]
    });
}
function ClassProductDetails(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-y-1 py-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "font-semibold m-0 flex-1",
                children: "Inversi\xf3n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-2xl font-medium lg:font-semibold text-green-500",
                children: product.price
            })
        ]
    });
}
function ClassRegisterLink(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-6 bg-gray-100 px-6 rounded-b-lg lg:rounded-b-xl xl:rounded-b-2xl w-full flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 focus:bg-green-600 text-white inline-flex px-6 py-2 lg:py-3 lg:text-lg xl:text-xl rounded-full font-medium lg:font-semibold text-center justify-center focus:outline-none",
            href: (0,buyTrainingLink/* default */.Z)(product.databaseId),
            children: "Reg\xedstrate en este curso"
        })
    });
}
function ClassInfoPanel(param) {
    var classDetails = param.classDetails;
    if (classDetails === null) {
        return null;
    }
    var hasLocation = classDetails.location !== null;
    var hasProduct = classDetails.product !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white rounded-lg lg:rounded-xl xl:rounded-2xl shadow-xl overflow-hidden ring-1 ring-black ring-opacity-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-900 rounded-t px-6 py-4 flex items-center space-x-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "text-white font-medium text-lg",
                    children: "Detalles del curso"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "divide-y px-6",
                children: [
                    hasProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassProductDetails, {
                        product: classDetails.product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center space-y-1 py-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "font-semibold m-0 flex-1",
                                children: "Modalidad"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassBadge/* default */.Z, {
                                type: classDetails.type,
                                roundedFull: true
                            })
                        ]
                    }),
                    hasLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col space-y-3 py-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                            className: "font-normal flex-1 flex items-start space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-5 h-5 text-gray-300 mt-1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                                        clipRule: "evenodd"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-lg flex-1",
                                    children: classDetails.location
                                })
                            ]
                        })
                    })
                ]
            }),
            hasProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassRegisterLink, {
                product: classDetails.product
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(95888);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
;// CONCATENATED MODULE: ./src/domain/Classes/ClassTrainers.js









function Trainer(param) {
    var title = param.title, uri = param.uri, featuredImage = param.featuredImage, showName = param.showName, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        className: "inline-flex",
        href: uri,
        ref: innerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center space-x-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-16 h-16 rounded-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: featuredImage.node.sourceUrl,
                        alt: title,
                        className: "block w-16 h-16 rounded-full"
                    })
                }),
                showName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-2 lg:space-y-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-semibold text-lg lg:text-xl leading-none",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "leading-none text-gray-500 text-sm lg:text-lg",
                            children: "Entrenador"
                        })
                    ]
                })
            ]
        })
    });
}
Trainer.defaultProps = {
    showName: false
};
Trainer.propTypes = {
    showName: (prop_types_default()).bool
};
var TrainerWithReference = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Trainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        innerRef: ref
    }));
});
function ClassTrainers(param) {
    var trainers = param.trainers;
    if (trainers === undefined || trainers === null || trainers.lenngth === 0) {
        return null;
    }
    var moreThanTwoTrainers = trainers.length > 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center space-x-2 lg:space-x-4",
        children: trainers.map(function(_param) /*#__PURE__*/ {
            var id = _param.id, title = _param.title, trainer = (0,_object_without_properties/* default */.Z)(_param, [
                "id",
                "title"
            ]);
            return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                tooltip: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerWithReference, (0,_object_spread/* default */.Z)({
                    title: title,
                    showName: moreThanTwoTrainers === false
                }, trainer))
            }, id);
        })
    });
};

// EXTERNAL MODULE: ./src/domain/Classes/ClassDatesBlocksList.js
var ClassDatesBlocksList = __webpack_require__(7122);
;// CONCATENATED MODULE: ./src/domain/Classes/ClassDatesCalendar.js


function ClassDatesCalendar(param) {
    var dates = param.dates;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col space-y-4 prose lg:prose-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-lg lg:text-xl font-semibold",
                children: "Calendario de clases"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap w-full gap-y-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassDatesBlocksList/* default */.Z, {
                    dates: dates
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/clases/[...slug].js






var __N_SSG = true;
function Class(param) {
    var clasx = param.clasx;
    var ref, ref1, ref2, ref3;
    // no class to render
    if (clasx === null) {
        return null;
    }
    var training = (ref = clasx.details) === null || ref === void 0 ? void 0 : ref.training;
    var trainers = (ref1 = clasx.details) === null || ref1 === void 0 ? void 0 : ref1.trainers;
    var dates = ((ref2 = clasx.details) === null || ref2 === void 0 ? void 0 : ref2.dates) || [];
    var hasObservations = ((ref3 = clasx.details) === null || ref3 === void 0 ? void 0 : ref3.observations) !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-gray-100 bg-gradient-to-br from-white to-gray-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-20 py-10 lg:pb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 lg:gap-10 xl:gap-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:col-span-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sticky top-28",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassInfoPanel, {
                                        training: training,
                                        classDetails: clasx.details
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-4 lg:col-span-8 lg:space-y-10 lg:pr-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                        className: "inline-flex items-center space-x-2 text-lg font-semibold text-green-500 hover:text-green-600",
                                        href: "/clases",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: "h-4 w-4",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 20 20",
                                                fill: "currentColor",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "Volver al calendario de clases"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-xl font-medium lg:text-4xl lg:font-bold lg:tracking-tight",
                                                children: training.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassTrainers, {
                                                trainers: trainers
                                            })
                                        ]
                                    }),
                                    hasObservations && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-4 rounded-lg bg-yellow-50 px-8 py-6 shadow ring-1 ring-black ring-opacity-10 lg:rounded-xl xl:rounded-2xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: "flex items-center space-x-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            className: "h-6 w-6 text-green-500",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                                                clipRule: "evenodd"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-xl font-semibold lg:text-2xl",
                                                        children: "Indicaciones generales"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "prose lg:prose-lg",
                                                dangerouslySetInnerHTML: {
                                                    __html: clasx.details.observations
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassDatesCalendar, {
                                        dates: dates
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "prose lg:prose-lg xl:prose-xl",
                                        dangerouslySetInnerHTML: {
                                            __html: clasx.content
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pointer-events-none absolute top-0 left-0 bottom-0 z-0 w-2/5 overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-20 -skew-y-6 transform",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-20 w-2/3 bg-gradient-to-r from-green-400 to-transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-20 w-2/4 bg-gradient-to-r from-green-300 to-transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-20 w-full bg-gradient-to-r from-green-100 to-transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-20 w-full bg-gradient-to-r from-green-200 to-transparent"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87847); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);